import { ColorDot } from '@purpur/library';
import styled from 'styled-components';

import {
    getPurpurBorder,
    getPurpurColor,
    getPurpurSpacing,
    getPurpurTypography,
    purpurMedia,
} from '@telialt/common-theme/src/purpurSelectors';

export const ProductPreOrderStockStatusWrapper = styled.section`
    align-items: center;
    box-sizing: border-box;
    display: grid;
    grid-template-columns: 1rem 1fr;
    column-gap: ${getPurpurSpacing('200')};
    width: 100%;
    padding: ${getPurpurSpacing('400')} ${getPurpurSpacing('200')};
    background-color: ${getPurpurColor('gray50')};
    border: ${getPurpurBorder('widthXs')} solid ${getPurpurColor('gray100')};

    ${purpurMedia('lg')`
        padding: ${getPurpurSpacing('400')} ${getPurpurSpacing('200')};
    `}
`;

export const StockSubtext = styled.div`
    color: ${getPurpurColor('gray700')};
    font-size: ${getPurpurTypography('scale75')};
    line-height: ${getPurpurTypography('lineHeightLoose')};
    grid-column: 2;
    grid-row: 2;
    white-space: break-spaces;
`;

export const OutOfStockStatusContainer = styled.section`
    border-top: ${getPurpurBorder('widthXs')} solid ${getPurpurColor('gray100')};
    border-bottom: ${getPurpurBorder('widthXs')} solid ${getPurpurColor('gray100')}; // within LTCONT-23318 bottom border should be removed, every component in PDP should assign border-top
    align-items: center;
    background-color: ${getPurpurColor('functionalWhite')};
    box-sizing: border-box;
    display: grid;
    grid-template-columns: 1rem 1fr;
    column-gap: ${getPurpurSpacing('200')};
    color: ${getPurpurColor('textStatusErrorMedium')};
    padding: ${getPurpurSpacing('400')} ${getPurpurSpacing('200')};
    ${purpurMedia('lg')`
        padding: ${getPurpurSpacing('400')} 0;
    `}
`;

export const StatusColorDot = styled(ColorDot).attrs({ variant: 'static', size: 'sm' })`
    width: ${getPurpurSpacing('200')};
    height: ${getPurpurSpacing('200')};
`;
